import Spinner from 'react-bootstrap/Spinner';
import {
    FiMail, FiSearch, FiChevronDown, FiChevronUp,
    FiExternalLink, FiInbox, FiShield, FiChevronLeft, FiChevronRight,
} from 'react-icons/fi';

import { useEffect } from "react";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver';
import { callApi, getCurSiteId } from '../lib/Common_funcs.js';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv != 'aws');


export const StDashContactForms = () => {
    const Max_items = 10;
    const { loginAction, logOut } = useAuth();

    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [numForms, setNumForms] = useState(0);
    const [formData, setFormData] = useState([]);
    const [visibleList, setVisibleList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [moreData, setMoreData] = useState(false);
    const [numPages, setNumPages] = useState(0);
    const [showNext, setShowNext] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [pageIndices, setPageIndices] = useState([]);
    const [curPage, setCurPage] = useState(1);
    const [acctSid, setAcctSid] = useState('');
    const [siteId, setSiteid] = useState(getCurSiteId() || '');
    const [act_e, setAct_E] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('date');
    const [sortOrder, setSortOrder] = useState('desc');
    const [expandedId, setExpandedId] = useState(null);

    const [totalPages, setTotalPages] = useState([]);

    const isMounted = useRef(false);

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return 'https://192.168.1.215:5000';
        }
    }

    const fetchData = async () => {
        try {
            setLoading2(true);
            totalPages.push(curPage)
            let lastKey = null;
            if (curPage > 1) {
                if (pageIndices.length >= (curPage - 1)) {
                    lastKey = pageIndices[curPage - 2];
                }
                else {
                    throw new Error("pageIndices not available!!!");
                    return false;
                }
            }

            if (formData.length > ((curPage - 1) * Max_items)) {
                return true;
            }

            const fetchUrl = '/sites/' + siteId + '/contactForms'
                + (((lastKey !== undefined) && (lastKey !== null)) ? "?lastForm=" + lastKey : '');

            const rcJson = await callApi(fetchUrl, 'GET', {}, {});

            if (rcJson.disposition == 'logout') {
                logOut();
            }

            if (rcJson.httpStatus != 200) {
                if (rcJson.disposition == 'retry') {
                    Tdebug && console.log(rcJson.message);
                }
                else if (rcJson.disposition == 'abort') {
                    Tdebug && console.log(rcJson.message);
                }
                else if (rcJson.disposition == 'empty') {
                    Tdebug && console.log(rcJson.message);
                }

                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }

                return false;
            }
            else {
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }

                if (parseInt(rcJson.respBody.formCount)) {
                    const cnt = rcJson.respBody.formCount;

                    const curPageStartIdx = (curPage - 1) * Max_items;

                    if ((cnt == 0) ||
                        ((formData.length > curPageStartIdx) && (rcJson.respBody.forms[0].formId == formData[curPageStartIdx].formId))) {
                        return true;
                    }

                    let newFormData = [...formData];

                    for (let fcnt = 0; fcnt < cnt; fcnt++) {
                        newFormData.push({
                            formId: rcJson.respBody.forms[fcnt].formId,
                            formDate: rcJson.respBody.forms[fcnt].formDate,
                            formEmail: rcJson.respBody.forms[fcnt].formEmail,
                            formSubject: rcJson.respBody.forms[fcnt].formSubject,
                            formMessage: rcJson.respBody.forms[fcnt].formMessage,
                            formName: rcJson.respBody.forms[fcnt].formName
                        });
                    }

                    setFormData(newFormData);

                    if (rcJson.respBody.moreItems == true) {
                        setMoreData(true);
                        pageIndices.push(rcJson.respBody.forms[rcJson.respBody.formCount - 1].formId);
                        setPageIndices(pageIndices);
                    }
                    else {
                        setMoreData(false);
                    }

                    setCurPage(curPage);
                    setNumPages(numPages + 1);
                    setLoading(false);
                    setLoading2(false);
                }

                return true;
            }
        } catch (axe) {
            Tdebug && console.log(axe);
            return false;
        }
    }

    const sortData = (data) => {
        return [...data].sort((a, b) => {
            let aValue, bValue;

            switch (sortBy) {
                case 'date':
                    const toSortable = (d) => d ? d.substring(4, 8) + d.substring(0, 2) + d.substring(2, 4) : '';
                    aValue = toSortable(a.formDate);
                    bValue = toSortable(b.formDate);
                    break;
                case 'email':
                    aValue = a.formEmail.toLowerCase();
                    bValue = b.formEmail.toLowerCase();
                    break;
                case 'name':
                    aValue = (a.formName || '').toLowerCase();
                    bValue = (b.formName || '').toLowerCase();
                    break;
                default:
                    aValue = a.formDate;
                    bValue = b.formDate;
            }

            if (sortOrder === 'asc') {
                return aValue > bValue ? 1 : -1;
            } else {
                return aValue < bValue ? 1 : -1;
            }
        });
    };

    const filterAndSortData = () => {
        let filtered = visibleList;

        if (searchTerm) {
            filtered = visibleList.filter(item =>
                item.formEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (item.formName && item.formName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                item.formMessage.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // filtered = sortData(filtered);
        setFilteredList(filtered);
    };

    useEffect(() => {
        filterAndSortData();
    }, [searchTerm, sortBy, sortOrder, visibleList]);

    useEffect(() => {
        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            return;
        }

        const fetchForms = async () => {
            await fetchData();
            setLoading(false)
        }

        if (((formData.length > ((curPage - 1) * Max_items)))) {
            if ((!visibleList.length) ||
                ((visibleList.length) && (visibleList[0].formId != formData[(curPage - 1) * Max_items].formId))) {

                let newList = [];
                let vidx = (curPage - 1) * Max_items;
                while ((vidx < ((curPage - 1) * Max_items) + Max_items) && (formData.length > vidx)) {
                    newList.push(formData[vidx]);
                    vidx++;
                }

                setVisibleList(newList);

                if ((curPage < numPages) || (curPage == numPages && moreData == true)) {
                    setShowNext(true);
                }
                else {
                    setShowNext(false);
                }

                if (curPage > 1) {
                    setShowPrev(true);
                }
                else {
                    setShowPrev(false);
                }
            }

            return;
        }
        else {
            (async () => {
                const res = await fetchForms();
                console.log(res)
            })()
        }

        return () => {
            return;
        }
    },);

    useEffect(() => {
        if (((formData.length > ((curPage - 1) * Max_items)))) {
            if ((!visibleList.length) ||
                ((visibleList.length) && (visibleList[0].formId != formData[(curPage - 1) * Max_items].formId))) {

                let newList = [];
                let vidx = (curPage - 1) * Max_items;
                while ((vidx < ((curPage - 1) * Max_items) + Max_items) && (formData.length > vidx)) {
                    newList.push(formData[vidx]);
                    vidx++;
                }

                setVisibleList(newList);

                if ((curPage < numPages) || (curPage == numPages && moreData == true)) {
                    setShowNext(true);
                }
                else {
                    setShowNext(false);
                }

                if (curPage > 1) {
                    setShowPrev(true);
                }
                else {
                    setShowPrev(false);
                }
            }
        }
    }, [curPage, formData, showPrev, showNext, visibleList, numForms, pageIndices]);

    const handleNextPage = () => {
        try {
            if (curPage > pageIndices.length) {
                return;
            }
            isMounted.current = false;
            // totalPages.push(curPage);
            setCurPage(curPage + 1);
            console.log("Total Pages: ", totalPages);
        } catch (error) {
            console.log("Contact Form Pagination Error: ", error);
        }
    }

    const handlePrevPage = () => {
        if (curPage == 1) {
            return;
        }
        setCurPage(curPage - 1);
    }

    const formatDate = (dateString) => {
        if (!dateString || dateString.length < 8) return dateString;
        const month = dateString.substring(0, 2);
        const day = dateString.substring(2, 4);
        const year = dateString.substring(4, 8);
        return `${month}/${day}/${year}`;
    };

    const getMailtoHref = (email) => {
        return "mailto:" + email;
    }

    const handleSortChange = (newSortBy) => {
        if (sortBy === newSortBy) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(newSortBy);
            setSortOrder('desc');
        }
    };

    const btnBase = {
        display: 'flex', alignItems: 'center', gap: '6px',
        border: 'none', borderRadius: 'var(--radius-md)', fontSize: '13px',
        fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
        transition: 'all 150ms ease',
    };

    if (loading) {
        return (
            <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
                    <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="app-content animate-in">
            <div className="dashboard-header">
                <h1 className="dashboard-title">Contact Forms</h1>
                <p className="dashboard-subtitle">View and manage contact form submissions from your website</p>
            </div>

            {/* Integration info banner */}
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                gap: '16px', flexWrap: 'wrap',
                background: 'var(--accent-soft)', border: '1px solid rgba(37,99,235,0.15)',
                borderRadius: 'var(--radius-md)', padding: '12px 16px', marginBottom: '24px',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FiShield size={16} style={{ color: 'var(--accent-primary)', flexShrink: 0 }} />
                    <div>
                        <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '2px' }}>Integration Instructions</div>
                        <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Use these credentials to integrate contact forms with your website.</div>
                    </div>
                </div>
                <a
                    href="https://www.turbosteed.com/blogs/contact-forms"
                    target="_blank" rel="noopener noreferrer"
                    style={{ ...btnBase, padding: '7px 14px', background: 'var(--accent-primary)', color: 'white', textDecoration: 'none', flexShrink: 0 }}
                >
                    <FiExternalLink size={13} /> View Guide
                </a>
            </div>

            {/* Search toolbar — temporarily disabled */}
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ position: 'relative', flex: 1, maxWidth: '320px' }}>
                    <FiSearch size={15} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
                    <input
                        type="text"
                        placeholder="Search by name, email or message..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: '100%', padding: '9px 12px 9px 36px',
                            border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)',
                            fontSize: '13px', background: 'var(--bg-secondary)',
                            color: 'var(--text-primary)', fontFamily: 'inherit', outline: 'none',
                        }}
                    />
                </div>
                <button
                    onClick={() => handleSortChange('date')}
                    style={{ ...btnBase, padding: '8px 14px', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }}
                >
                    {sortOrder === 'desc' ? <FiChevronDown size={14} /> : <FiChevronUp size={14} />}
                    {sortOrder === 'desc' ? 'Newest first' : 'Oldest first'}
                </button>
            </div> */}

            {/* Forms list */}
            {loading2 ? (
                <div className="bento-card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '40px' }}>
                    <Spinner animation="border" style={{ width: '1.25rem', height: '1.25rem', borderWidth: '2px', color: 'var(--accent-primary)' }} />
                    <span style={{ fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading submissions...</span>
                </div>
            ) : visibleList.length === 0 ? (
                <div className="bento-card" style={{ textAlign: 'center', padding: '48px' }}>
                    <FiInbox size={40} style={{ color: 'var(--text-tertiary)', marginBottom: '12px', opacity: 0.4 }} />
                    <p style={{ fontSize: '14px', fontWeight: 500, marginBottom: '4px', color: 'var(--text-primary)' }}>No Contact Forms Yet</p>
                    <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>Submissions will appear here once received.</p>
                </div>
            ) : (
                <>
                    <div className="bento-card" style={{ padding: 0, overflow: 'visible' }}>
                        {filteredList.map((item, idx) => (
                            <div key={item.formId} style={{ borderBottom: idx < filteredList.length - 1 ? '1px solid var(--border-subtle)' : 'none' }}>
                                {/* Row header */}
                                <div
                                    style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', cursor: 'pointer', transition: 'background 100ms ease' }}
                                    onClick={() => setExpandedId(expandedId === item.formId ? null : item.formId)}
                                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--bg-hover)'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                >
                                    <div style={{
                                        width: '38px', height: '38px', borderRadius: '50%',
                                        background: 'var(--accent-soft)', color: 'var(--accent-primary)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontWeight: 600, fontSize: '14px', flexShrink: 0, marginRight: '12px',
                                    }}>
                                        {(item.formName || item.formEmail || '?').charAt(0).toUpperCase()}
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px', flexWrap: 'wrap' }}>
                                            <span style={{ fontSize: '14px', fontWeight: 500 }}>{item.formName || 'Anonymous'}</span>
                                            <span style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>{item.formEmail}</span>
                                        </div>
                                        <div style={{ fontSize: '13px', color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {item.formMessage?.length > 80 ? item.formMessage.substring(0, 80) + '...' : item.formMessage}
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginLeft: '16px', flexShrink: 0 }}>
                                        {formatDate(item.formDate)}
                                    </div>
                                    <div style={{ marginLeft: '12px', color: 'var(--text-tertiary)', flexShrink: 0 }}>
                                        {expandedId === item.formId ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
                                    </div>
                                </div>

                                {/* Expanded message */}
                                {expandedId === item.formId && (
                                    <div style={{ padding: '0 16px 16px 66px', background: 'var(--bg-tertiary)' }}>
                                        <div style={{ padding: '14px 0 10px' }}>
                                            <div style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '6px' }}>Message</div>
                                            <p style={{ fontSize: '14px', lineHeight: 1.7, margin: 0, color: 'var(--text-primary)' }}>{item.formMessage}</p>
                                        </div>
                                        <a
                                            href={getMailtoHref(item.formEmail)}
                                            style={{ ...btnBase, padding: '7px 16px', background: 'var(--accent-gradient)', color: 'white', textDecoration: 'none', display: 'inline-flex' }}
                                        >
                                            <FiMail size={13} /> Reply
                                        </a>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    {(showNext || showPrev) && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginTop: '24px' }}>
                            <button
                                disabled={!showPrev}
                                onClick={handlePrevPage}
                                style={{ ...btnBase, padding: '7px 12px', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: !showPrev ? 'var(--text-tertiary)' : 'var(--text-primary)', opacity: !showPrev ? 0.5 : 1 }}
                            >
                                <FiChevronLeft size={14} /> Prev
                            </button>
                            {totalPages.map((pageNum, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurPage(pageNum)}
                                    style={{ ...btnBase, width: '36px', height: '36px', padding: 0, justifyContent: 'center', border: '1px solid var(--border-color)', background: pageNum === curPage ? 'var(--accent-primary)' : 'var(--bg-secondary)', color: pageNum === curPage ? 'white' : 'var(--text-primary)' }}
                                >
                                    {pageNum}
                                </button>
                            ))}
                            <button
                                disabled={!showNext}
                                onClick={handleNextPage}
                                style={{ ...btnBase, padding: '7px 12px', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: !showNext ? 'var(--text-tertiary)' : 'var(--text-primary)', opacity: !showNext ? 0.5 : 1 }}
                            >
                                Next <FiChevronRight size={14} />
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default StDashContactForms;
